// mycards strings (es).
// Machine-drafted — review with a native speaker before launch.
const mycards = {
	mycards: {
		// Status tabs
		tabAll: 'Todas',
		tabDraft: 'Borrador',
		tabSent: 'Enviadas',
		tabScheduled: 'Programadas',
		tabWorkflow: 'Flujo de trabajo',

		// View toggle
		gridView: 'Vista de cuadrícula',
		calendarView: 'Vista de calendario',

		// Search
		searchPlaceholder: 'Introduce el título de la tarjeta',

		// Date range filter
		last7Days: 'Últimos 7 días',
		last15Days: 'Últimos 15 días',
		last30Days: 'Últimos 30 días',
		last2Months: 'Últimos 2 meses',
		last6Months: 'Últimos 6 meses',
		lastYear: 'Último año',
		allCardsRange: 'Todas las tarjetas',

		viewMore: 'Ver más',

		// Empty state
		emptyState: 'Aún no tienes ninguna tarjeta. Haz clic en el botón de abajo para empezar.',
		createNewCard: 'Crear nueva tarjeta',

		// Folder bar
		foldersLabel: 'Carpetas',
		allCards: 'Todas las tarjetas',
		newFolder: 'Nueva carpeta',
		addFolder: 'Añadir',
		folderNamePlaceholder: 'Nombre de la carpeta',
		addRemoveCards: 'Añadir / quitar tarjetas',
		renameFolderText: 'Renombrar carpeta "%{name}"',
		deleteFolderTitle: '¿Eliminar "%{name}"?',
		deleteFolderText: 'Se eliminará la carpeta. Las tarjetas que contiene se conservan y solo se desarchivan.',

		// Assign cards modal
		cardsInFolder: 'Tarjetas en "%{name}"',
		selectedCount: '%{count} seleccionadas',
		searchCards: 'Buscar tarjetas…',
		noCardsFound: 'No se encontraron tarjetas.',
		untitledCard: 'Tarjeta sin título',
		btnSave: 'Guardar',
		btnSaving: 'Guardando…',

		// Shared buttons
		btnCancel: 'Cancelar',
		btnRename: 'Renombrar',
		btnDelete: 'Eliminar',
		btnNo: 'No',
		btnYes: 'Sí',
		btnEditAnyway: 'Editar de todos modos',

		// Folder handler errors
		couldNotCreateFolder: 'No se pudo crear la carpeta',
		couldNotRenameFolder: 'No se pudo renombrar la carpeta',
		couldNotDeleteFolder: 'No se pudo eliminar la carpeta',

		// Card handler dialogs
		cardAlreadyDeliveredTitle: 'La tarjeta ya fue entregada',
		cardAlreadyDeliveredText: 'Puedes clonar esta tarjeta para programar una nueva',
		workflowWarningTitle: 'Esta tarjeta se usa en un flujo de trabajo',
		workflowWarningText: 'Editar las etiquetas de combinación o el contenido puede romper tus flujos de trabajo existentes. ¿Seguro que quieres continuar?',
		openCardErrorTitle: 'Se produjo un problema al abrir esta tarjeta. Por favor, contacta con soporte',
		deleteCardTitle: '¿Estás seguro?',
		deleteCardText: '¿Quieres eliminar esta tarjeta?',
		errorTitle: 'Error',
	} as Record<string, string>,
};
export default mycards;
